import React, { useState, useRef, useEffect, useContext } from "react"; 
import { Col, Container, Row } from "react-bootstrap";
import ContactImg from "../../Images/contact-banner.png";
import LocatorImg from "../../Images/locator.png";
import FaxImg from "../../Images/fax.png";
import EmailImg from "../../Images/email.png";
import PhoneImg from "../../Images/phone.png";
import readmorearrow from "../../Images/readmore-arrow.png";
import "./Contact.css";
 
import URLstateContext from "../../provider/CommonContext";
import CallTrackApi from "../Activity_Track/CallTrackApi";
function Contact() {
    window.scrollTo(0, 0)
    const { BaseLiveURL } = useContext(URLstateContext);
  CallTrackApi("Contact Us",window.location.href);

    return(
        <>
            <section className="contact-sc">
                <section className="contact-main-1">
                    <Container>
                    <Row>
                        <Col xl={12}>
                            <h2 class="pageinnerhead text-center">Contact Us</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12}>
                            <h3 className="contactinner">Operations Office</h3>
                        </Col>
                        <Col xl={7} lg={7} md={8} sm={12}>
                            <div className="contact-main">
                                <div className="contact-1">
                                    <img src={LocatorImg} alt="location" className="img-fluid" />
                                    <h4>Address</h4>
                                    <p>6, Mansukh House, Pandav Nagar, Delhi-110092</p>
                                </div>
                                <div className="contact-2">
                                    <img src={PhoneImg} alt="location" className="img-fluid" />
                                    <h4>Phone </h4>
                                    <p>9638238000</p>
                                </div>
                                {/* <div className="contact-3">
                                    <img src={FaxImg} alt="location" className="img-fluid" />
                                    <h4>Fax </h4>
                                    <p>011-47617835, 011-61287835</p>
                                </div> */}
                                <div className="contact-3">
                                    <img src={EmailImg} alt="location" className="img-fluid" />
                                    <h4>Email Id </h4>
                                    <p>Support@moneysukh.com</p>
                                </div>
                            </div>
                        </Col>
                        <Col xl={5} lg={5} md={4} sm={12}>
                            <div className="contact-img">
                                <img src={ContactImg} alt="contact-img" className="img-fluid" />
                            </div>
                        </Col>
                    </Row>
                    </Container>
                </section>
                <section className="escalation-sc">
                    <Container>
                        <Row>
                            <Col>
                                <span className="esc-label">Escalation Matrix</span>
                                <span>    
                                    {/* <a href={BaseLiveURL + "files/Escalation-Matrix.pdf"}   target="_blank" className="clickhere-btn">Click Here <span><img src={readmorearrow}></img></span></a> */}
                                    {/* alt="Arrow Icon" */}
                                    <a href={"https://support.moneysukh.com/escalation-matrix/"}   target="_blank" className="clickhere-btn">Click Here <span><img src={readmorearrow} alt="Arrow Icon"></img></span></a>
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="branch-list-sc">
                    <Container>
                        <Row>
                            <Col xl={4} md={4} sm={12}>
                                <div className="branch-inner">
                                    <h3>Mansukh Securities & Finance <br />Limited</h3>
                                    <label>Compliance officer</label>
                                    <p>Mr. Sandeep Kumar</p>
                                    <label>Email ID</label>
                                    <p>sandeepkumar@moneysukh.com</p>
                                    <label>Phone No</label>
                                    <p>91-11-47617830, 91-11-61287830</p>
                                </div>
                            </Col>
                            <Col xl={4} md={4} sm={12}>
                                <div className="branch-inner">
                                    <h3>Mansukh Stock Brokers <br />Limited</h3>
                                    <label>Compliance officer</label>
                                    <p>Mr. Kapil Awal</p>
                                    <label>Email ID</label>
                                    <p>kapilawal@moneysukh.com</p>
                                    <label>Phone No</label>
                                    <p>91-11-47617890, 91-11-61287890</p>
                                </div>
                            </Col>
                            <Col xl={4} md={4} sm={12}>
                                <div className="branch-inner">
                                    <h3>Algocomm Futures Private <br />Limited</h3>
                                    <label>Compliance officer</label>
                                    <p>Mr. Paras Khandelwal</p>
                                    <label>Email ID</label>
                                    <p>paras@moneysukh.com</p>
                                    <label>Phone No</label>
                                    <p>91-11-47617860, 91-11-61287860</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </section>
        </>
    );
}
export default Contact;